<template>
  <vs-popup class="user-edit-popup"
            id="popup"
            title="CREATE STAFF"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required|max:50" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="createStaffForm.name"   name="name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input  v-model="createStaffForm.email" class="w-full"  name="email" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="address" name="address" rules="max:100" v-slot="{ errors }">
              <small class="label">Address</small>
              <vs-textarea v-model="createStaffForm.address_1" height="100px"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="user_group" name="user_group" rules="required" v-slot="{ errors }">
                <small class="label">User Group</small>
                <v-select name="user_group" :reduce="option => option.id" v-model="createStaffForm.role_id" label="name" :closeOnSelect="true"  :options="roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="contact_1" name="contact_1" rules="contactNumber|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Mobile</small>
                <vs-input v-model="createStaffForm.contact_1" class="w-full"  name="contact_1" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-8">
            <div class="vx-col md:w-full md:mb-0">
              <small class="label">Is this user an account manager/handler?</small>
              <vs-switch v-model="createStaffForm.is_account_handler" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="dep" name="dep" rules="required" v-slot="{ errors }">
                <small class="label">Departments</small>
                <v-select name="dep" label="name" multiple :closeOnSelect="false" v-model="createStaffForm.department_ids"
                          :options="departments" :reduce="option => option.id"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
              <div class="vx-row mt-4">
                <vs-button v-if="createStaffForm.department_ids.length !== departments.length" @click.stop="onClickSelectAll" size="small" class="ml-4">Select all</vs-button>
                <vs-button v-if="createStaffForm.department_ids.length > 0" @click.stop="onClickRemoveAllDeps" color="danger" size="small" class="ml-4">Clear all</vs-button>
              </div>
            </div>
            <!-- <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="reports" name="reports" rules="" v-slot="{ errors }">
                <small class="label">Reports</small>
                <v-select name="reports" multiple label="name" :closeOnSelect="false" :reduce="option => option.id"
                          v-model="createStaffForm.reports" :options="reports" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
              <div class="vx-row mt-4">
                <vs-button v-if="createStaffForm.reports.length !== reports.length" @click.stop="onClickSelectAllReport" size="small" class="ml-4">Select all</vs-button>
                <vs-button v-if="createStaffForm.reports.length > 0" @click.stop="onClickRemoveAllReports" color="danger" size="small" class="ml-4">Clear all</vs-button>
              </div>
            </div> -->
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const TenantRepository = RepositoryFactory.get('tenant');

  const StaffRepository = RepositoryFactory.get('staff')
  const ReportingRepository = RepositoryFactory.get('reporting');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      roles: [],
      selectedStaff: {},
      departments: [],
      updateStaffSelected: [],
      createStaffForm: {
        department_ids: [],
        reports: [],
        is_account_handler: false
      },
      reports: [],
      tenant_id: null
    }
  }

export default {
  name: 'CreateTenantStaffPopUp',
  data () {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],

  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.open = true;
        this.tenant_id = this.$route.params.id
        await this.loadRoles();
        await this.loadDepartments();
        // await this.loadReports();
      } catch (error) {

      }
    },

    async onClickCreateStaffUser () {
      const vue = this;
      // this.$vs.loading()
       try {
         await StaffRepository.createStaff(this.tenant_id, this.createStaffForm)
         this.showSuccessMessage('New staff created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
        console.log(e);
        //  this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      // this.$vs.loading.close()
    },

    async loadDepartments() {
      const {data} = await TenantRepository.getTenantDepartmentList(this.tenant_id)
      this.departments =  data.data
    },
    async loadReports() {
      this.$vs.loading();
      const {data} = await ReportingRepository.getListOfChartManage()
      this.reports =  data.data
      this.$vs.loading.close()
    },
    async loadRoles() {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.50
      });
      try {
        this.roles = [];
        const {data} = await TenantRepository.getTenantRoleList(this.tenant_id)
        this.roles =  data.data
      } catch (error) {
        this.convertAndNotifyError(error)
        this.open = false
      }
      await this.$vs.loading.close('#popup > .con-vs-loading')
    },

    async getStaff(id) {
      const { data } = await StaffRepository.getStaff(id)
      this.selectedStaff = data.data
    },
    onClickReset() {
      this.createStaffForm = {}
    },
    onClickSelectAll() {
      this.createStaffForm.department_ids.splice(0, this.createStaffForm.department_ids.length)
      this.departments.map((dep) => {
          this.createStaffForm.department_ids.push(dep.id)
      })  
    },
    onClickRemoveAllDeps() {
      this.createStaffForm.department_ids.splice(0, this.createStaffForm.department_ids.length)
    },
    async onClickSelectAllReport() {
      this.createStaffForm.reports.splice(0, this.createStaffForm.reports.length)
      this.reports.map((rep) => {
          this.createStaffForm.reports.push(rep.id)
      })  
    },
    onClickRemoveAllReports() {
      this.createStaffForm.reports.splice(0, this.createStaffForm.reports.length)
    },
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
